import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import ExclamationCircle from 'dibs-icons/exports/legacy/ExclamationCircle';

import styles from './EthereumError.scss';

type Props = {
    persistedAddress: string;
};

export const EthereumMismatchedAddressError: FC<Props> = ({ persistedAddress }) => {
    return (
        <div className={styles.container}>
            <div className={styles.alertBox}>
                <ExclamationCircle className={styles.exclamationIcon} />
                <p>
                    <FormattedMessage
                        id="ethereum.mismatchedAddressError.copy1"
                        defaultMessage="The wallet address you are currently connected to does not match the wallet address associated with your 1stDibs account."
                    />
                </p>
            </div>
            <p>
                <FormattedMessage
                    id="ethereum.mismatchedAddressError.copy2"
                    defaultMessage="Please switch your wallet address to <b>({persistedAddress})</b> in MetaMask in order to proceed."
                    values={{ persistedAddress, b: chunks => <strong>{chunks}</strong> }}
                />
            </p>
        </div>
    );
};
